export const GA_COOKIE_NAME = 'gatsby-gdpr-google-analytics';
export const GA_DISABLE_FLAG = `ga-disable-${process.env.REACT_APP_GA_TRACKING_ID}`;
export const ONETRUST_DATA_DOMAIN_SCRIPT = process.env.REACT_APP_ONETRUST_DATA_DOMAIN_SCRIPT || '';
